import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DispatcherClass;
function Dispatcher() {
  if (DispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Dispatcher', VOID, VOID, VOID, [1]);
    DispatcherClass = $;
  }
  return DispatcherClass;
}
var DeletePairAssignmentsCommandClass;
function DeletePairAssignmentsCommand() {
  if (DeletePairAssignmentsCommandClass === VOID) {
    class $ {
      constructor(partyId, pairingSetId) {
        this.b2m_1 = partyId;
        this.c2m_1 = pairingSetId;
      }
      toString() {
        return 'DeletePairAssignmentsCommand(partyId=' + this.b2m_1.toString() + ', pairingSetId=' + this.c2m_1.toString() + ')';
      }
      hashCode() {
        var result = this.b2m_1.hashCode();
        result = imul(result, 31) + this.c2m_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeletePairAssignmentsCommand()))
          return false;
        if (!this.b2m_1.equals(other.b2m_1))
          return false;
        if (!this.c2m_1.equals(other.c2m_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DeletePairAssignmentsCommand');
    DeletePairAssignmentsCommandClass = $;
  }
  return DeletePairAssignmentsCommandClass;
}
//region block: exports
export {
  Dispatcher as Dispatcher2k7js8ct0qtp5,
  DeletePairAssignmentsCommand as DeletePairAssignmentsCommand24dwr1itx84a,
};
//endregion

//# sourceMappingURL=DeletePairAssignmentsCommand.mjs.map
